import { getNavigationMappedData } from '../selectors';

export default (state, response, options = {}) => {
    const { view, selectedId, locale } = options;

    if (!response || !response.GiftList) {
        return {
            wishlistsList: [],
        };
    }

    const wishlistsList = getNavigationMappedData(response, view, selectedId, locale);

    return {
        ...state,
        wishlistsList,
    };
};
